export default __webpack_public_path__ + "static/sharingcloud_logo-d3c62ac8b4aacf42c946e1b1b688755c.png";